<template>
	<div>
		<ui-clipboard-input
			v-model="link"
			:disabled="isFetching || link.length === 0"
			hint="Link copied to clipboard"
			label="Live stream link"
		/>
		<ui-dialog-footer>
			<ui-button
				:disabled="isFetching || link.length > 0"
				primary
				text="Generate link"
				tooltip="Generate password protected link"
				@click="fetchShareStreamLink"
			/>
		</ui-dialog-footer>
	</div>
</template>

<script>
import alert from "lib/modules/Alert";
import http from "lib/modules/Http";
import UiButton from "lib/components/ui/Button";
import UiClipboardInput from "lib/components/ui/ClipboardInput";
import UiDialogFooter from "lib/components/ui/DialogFooter";

export default {
	name: "StreamShareLink",
	components: {
		UiButton,
		UiClipboardInput,
		UiDialogFooter
	},
	props: {
		password: {
			type: String,
			default: "",
			required: false
		},
		streamId: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			isFetching: false,
			link: ""
		};
	},
	watch: {
		password(val) {
			if (val.length === 0)
				this.setLegacyLink();
			else {
				this.link = "";
			}
		}
	},
	mounted() {
		this.setLegacyLink();
	},
	methods: {
		fetchShareStreamLink() {
			const parameters = {
				key: this.password,
				lifetime: 4294967295
			};

			this.isFetching = true;

			http.post(`/api/v2/recorder/stream/${this.streamId}/share`, parameters)
			.then((response) => {
				this.link = `${location.origin}/live?id=${encodeURIComponent(response.data.secid)}`;
			})
			.catch((error) => {
				alert.error("Unable to generate link", error.response);
			})
			.finally(() => {
				this.isFetching = false;
			});
		},
		setLegacyLink() {
			this.link = `${location.origin}/live/${this.streamId}`;
		}
	}
};
</script>
